import { requestByPOST } from 'lib/requests'
import { buildApplePayValidateMerchantRequest } from './utils'

const END_POINTS = {
  APPLEPAY_VALIDATE_MERCHANT: '/applepay/validate',
}

export async function validateMerchantApplePay(params) {
  return requestByPOST({
    endpoint: END_POINTS.APPLEPAY_VALIDATE_MERCHANT,
    data: buildApplePayValidateMerchantRequest(params),
  })
}
